export const DATA = [
    {
        title: "Brand Creation and Registration:",
        items: [
            "Initiate your journey by creating your brand.",
            "Provide all essential information, ensuring a comprehensive profile.",
            "Elevate your brand's identity by uploading your logo for instant recognition.",
        ],
    },
    {
        title: "Product Creation:",
        items: [
            "Access your dedicated brand page.",
            "Dive into product creation by clicking on \"New Product.\"",
            "Start inputting essential product details, with some fields being mandatory and others providing flexibility based on your preferences.",
        ],
    },
    {
        title: "Information Input and Customization:",
        items: [
            "Navigate through the product creation process, meticulously inputting all required information.",
            "Tailor your product details according to your brand's unique characteristics and preferences.",
        ],
    },
    {
        title: "Finalize and Publish:",
        items: [
            "Once satisfied with the inputted information, confidently click \"Publish\" to finalize your product creation.",
            "Congratulations! Your first product is now officially part of your brand's digital portfolio.",
        ],
    },
    {
        title: "Continued Brand Building:",
        items: [
            "Explore the option to add more products, ensuring a comprehensive representation of your brand's offerings.",
        ],
    },
    {
        title: "QR Code Download:",
        items: [
            "As a pivotal step in your brand's digital journey, download the QR code from your brand page.",
            "This QR code becomes a dynamic link to your product, facilitating easy access and engagement for your audience.",
        ],
    },
];